export function createNumberArray(ArrayConstructor, length) {
    if (ArrayConstructor === Array) {
        return new ArrayConstructor(length).fill(0);
    }
    else {
        return new ArrayConstructor(length);
    }
}
export function createDoubleArray(ArrayConstructor, length) {
    if (ArrayConstructor === Array) {
        return new ArrayConstructor(length).fill(0);
    }
    else {
        return new ArrayConstructor(length);
    }
}
//# sourceMappingURL=createArray.js.map